<template>
  <div class="edit web">
    <el-form ref="form" :model="schoolForm" :rules="editRule">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="园所名称" class="boxHei" prop="name">
            <el-input
              class="boxWid"
              v-model="schoolForm.name"
              placeholder="请输入园所名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="负责人" class="boxHei">
            <el-input
              class="boxWid"
              v-model="schoolForm.charge_name"
              placeholder="请输入负责人"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="手机号码"
            class="boxHei shortMessageTextBox"
            prop="mobile"
          >
            <el-input
              class="boxWid"
              v-model.number="schoolForm.mobile"
              placeholder="请输入手机号码"
            />
            <el-button
              v-show="shortShow"
              type="text"
              class="shortMessageText"
              @click="getShortMessage"
            >
              <el-divider direction="vertical"></el-divider>获取验证码
            </el-button>
            <el-button
              disabled
              v-show="!shortShow"
              type="text"
              class="shortMessageText"
            >
              <el-divider direction="vertical"></el-divider>
              {{ count }}s后获取
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="验证码" class="boxHei">
            <el-input
              class="boxWid"
              v-model.number="schoolForm.code"
              placeholder="请输入验证码"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="机构类型" class="boxHei">
            <el-select
              class="boxWid"
              v-model="schoolForm.company_type"
              placeholder="请选择机构类型"
            >
              <el-option
                v-for="(item, index) in typePicker"
                :key="index"
                :label="item.name"
                :value="item.active"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="园所性质" class="boxHei">
            <el-select
              class="boxWid"
              multiple
              v-model="schoolForm.quality"
              placeholder="请选择园所性质"
            >
              <el-option
                v-for="(item, index) in natureList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="园所规模" class="boxHei">
            <el-select
              class="boxWid"
              v-model="schoolForm.scale"
              placeholder="请选择园所规模"
            >
              <el-option
                v-for="(item, index) in scaleList"
                :key="index"
                :label="item.name"
                :value="item.active"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="福利标签" class="boxHei">
            <el-select
              class="boxWid"
              multiple
              v-model="schoolForm.label"
              placeholder="请选择福利标签"
            >
              <el-option
                v-for="(item, index) in labelList"
                :key="index"
                :label="item.label_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="园所介绍">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4 }"
              placeholder="请输入内容"
              v-model="schoolForm.desc"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="地址">
            <el-autocomplete
              class="boxWid"
              v-model="schoolForm.address"
              placeholder="请输入地址"
              :fetch-suggestions="searchMap"
              @select="changeAddress"
            >
              <template slot-scope="{ item }">
                <div class="name">
                  {{
                    (item.pname ? item.pname : "") +
                    (item.cityname ? item.cityname : "") +
                    (item.adname ? item.adname : "") +
                    item.name
                  }}
                </div>
              </template>
            </el-autocomplete>
            <div style="margin-top: 10px">
              <Amap
                ref="map"
                :longitude="schoolForm.longitude"
                :latitude="schoolForm.latitude"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <div style="color: #606266">园所相册</div>
            <el-upload
              :file-list="schoolForm.photo"
              list-type="picture-card"
              :http-request="PhotoFun"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <div style="color: #606266">营业执照或办园许可证</div>
            <el-upload
              :file-list="schoolForm.require_pic"
              list-type="picture-card"
              :http-request="BusinessFun"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="text-align: center">
            <el-button @click="resizeSchool">取消</el-button>
            <el-button type="primary" @click="schoolSubmit">保存</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Amap from "@/components/map";
export default {
  components: {
    Amap,
  },
  data() {
    return {
      loading: true,
      editType: false,
      schoolForm: {},

      // 规模
      scaleList: [
        {
          active: 1,
          name: "5个班以下",
        },
        {
          active: 2,
          name: "5-10个班",
        },
        {
          active: 3,
          name: "10~15个班",
        },
        {
          active: 4,
          name: "15~20个班",
        },
        {
          active: 5,
          name: "20个班以上",
        },
      ],

      // 机构类型
      typePicker: [
        {
          active: 1,
          name: "幼儿园",
        },
        {
          active: 2,
          name: "早教/托育机构",
        },
        {
          active: 3,
          name: "综合教育公司",
        },
        {
          active: 4,
          name: "其他",
        },
      ],

      //   福利待遇
      labelList: [
        {
          id: "26",
          label_name: "寒暑假",
          label_desc: "寒暑假",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 0,
          label_addTime: 1572340894,
        },
        {
          id: "27",
          label_name: "就读优惠",
          label_desc: "子女入学优惠",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 0,
          label_addTime: 1572340919,
        },
        {
          id: "28",
          label_name: "节日福利",
          label_desc: "节日福利",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 0,
          label_addTime: 1572341156,
        },
        {
          id: "24",
          label_name: " 社保",
          label_desc: "社保",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 1,
          label_addTime: 1559107218,
        },
        {
          id: "23",
          label_name: " 双休",
          label_desc: " 双休",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 2,
          label_addTime: 1559107202,
        },
        {
          id: "22",
          label_name: " 包吃",
          label_desc: "包吃",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 3,
          label_addTime: 1559107192,
        },
        {
          id: "21",
          label_name: "包住",
          label_desc: "包住",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 4,
          label_addTime: 1559107181,
        },
        {
          id: "20",
          label_name: "餐补",
          label_desc: "餐补",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 5,
          label_addTime: 1559106888,
        },
        {
          id: "19",
          label_name: "房补 ",
          label_desc: "房补",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 6,
          label_addTime: 1559106874,
        },
        {
          id: "18",
          label_name: "全勤奖",
          label_desc: "全勤奖",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 10,
          label_addTime: 1559106865,
        },
        {
          id: "17",
          label_name: "年终奖",
          label_desc: "年终奖",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 11,
          label_addTime: 1559106856,
        },
        {
          id: "16",
          label_name: "有提成",
          label_desc: "有提成",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 12,
          label_addTime: 1559106848,
        },
        {
          id: "15",
          label_name: "年度旅游",
          label_desc: "年度旅游",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 16,
          label_addTime: 1559106838,
        },
        {
          id: "14",
          label_name: "五险一金",
          label_desc: "五险一金",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 17,
          label_addTime: 1559106826,
        },
        {
          id: "13",
          label_name: "通讯补贴",
          label_desc: "通讯补贴",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 18,
          label_addTime: 1559106817,
        },
        {
          id: "12",
          label_name: "年底双薪",
          label_desc: "年底双薪",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 19,
          label_addTime: 1559106804,
        },
        {
          id: "11",
          label_name: "年终分红",
          label_desc: "年终分红 ",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 20,
          label_addTime: 1559106782,
        },
        {
          id: "10",
          label_name: "加班补助",
          label_desc: "加班补助",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 21,
          label_addTime: 1559106771,
        },
        {
          id: "9",
          label_name: "带薪年假 ",
          label_desc: "带薪年假 ",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 22,
          label_addTime: 1559106762,
        },
        {
          id: "7",
          label_name: "交通补贴",
          label_desc: "交通补贴",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 24,
          label_addTime: 1559106743,
        },
        {
          id: "6",
          label_name: "高温补贴",
          label_desc: "高温补贴",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 25,
          label_addTime: 1559106735,
        },
        {
          id: "5",
          label_name: "采暖补贴 ",
          label_desc: "采暖补贴 ",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 26,
          label_addTime: 1559106727,
        },
        {
          id: "4",
          label_name: "弹性工作",
          label_desc: "弹性工作",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 27,
          label_addTime: 1559106692,
        },
        {
          id: "3",
          label_name: "医疗保险",
          label_desc: "医疗保险",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 28,
          label_addTime: 1559106683,
        },
        {
          id: "2",
          label_name: "定期体检",
          label_desc: "定期体检",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 29,
          label_addTime: 1559106669,
        },
        {
          id: "25",
          label_name: "免费班车",
          label_desc: "免费班车",
          label_icon: "",
          label_status: 1,
          label_group: 3,
          label_sort: 30,
          label_addTime: 1560596713,
        },
      ],

      //   职位
      list: [],

      //   收到的简历
      receivedList: [],

      //   园所性质
      natureList: [
        {
          id: "0",
          name: "私立园",
          active: false,
        },
        {
          id: "1",
          name: "集团园",
          active: false,
        },
        {
          id: "2",
          name: "集体办园",
          active: false,
        },
        {
          id: "3",
          name: "公办园",
          active: false,
        },
        {
          id: "4",
          name: "省一级示范园",
          active: false,
        },
        {
          id: "5",
          name: "市一级示范园",
          active: false,
        },
        {
          id: "6",
          name: "区一级示范园",
          active: false,
        },
        {
          id: "7",
          name: "新开园",
          active: false,
        },
        {
          id: "8",
          name: "连锁园",
          active: false,
        },
        {
          id: "9",
          name: "连锁机构",
          active: false,
        },
        {
          id: "10",
          name: "新型公办园",
          active: false,
        },
        {
          id: "11",
          name: "其他",
          active: false,
        },
      ],

      editRule: {
        name: [
          { required: true, message: "请输入园所名称", trigger: "blur" },
          { max: 14, message: "园所名称最多14个字", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机", trigger: "blur" },
          { type: "number", message: "请输入正确的手机" },
        ],
      },

      addressList: [],

      shortShow: true,
      count: "",
      timer: null,
    };
  },
  methods: {
    // 搜索地图
    searchMap(o, cb) {
      this.$axios({
        method: "get",
        url:
          "https://restapi.amap.com/v3/place/text?key=da434aca7336bc518af0a18daaf9b2da&keywords=" +
          o,
      }).then(function (res) {
        cb(res.data.pois);
      });
    },

    // 选择地址
    changeAddress(o) {
      this.schoolForm.address =
        (o.pname ? o.pname : "") +
        (o.cityname ? o.cityname : "") +
        (o.adname ? o.adname : "") +
        o.name;
      this.schoolForm.latitude = o.location.split(",")[1];
      this.schoolForm.longitude = o.location.split(",")[0];
      this.schoolForm.province_name = o.pname;
      this.schoolForm.city_name = o.cityname;
      this.schoolForm.dist_name = o.adname;
      this.api
        .get("/5ce1f900906b8", {
          latitude: this.schoolForm.latitude,
          longitude: this.schoolForm.longitude,
        })
        .then((r) => {
          this.schoolForm.province = r.data.province.region_id;
          this.schoolForm.city = r.data.city.region_id;
          this.schoolForm.dist = r.data.district.region_id;
        });
      this.$nextTick(() => {
        this.$refs.map.init();
      });
    },

    // 获取短信验证码
    getShortMessage() {
      let obj = {
        mobile: JSON.stringify(this.schoolForm.mobile),
        device_id: JSON.parse(this.Cookies.get("DeviceId")).device_id,
      };
      this.api.post("/5cdb64c7ebcba", obj).then((r) => {
        const timeCount = 60;
        if (!this.timer) {
          this.count = timeCount;
          this.shortShow = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= timeCount) {
              this.count--;
            } else {
              this.shortShow = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },

    // 删除相册
    handleRemove(file, fileList) {
      this.schoolForm.photo = JSON.parse(JSON.stringify(fileList));
    },

    // 上传相册
    PhotoFun(f) {
      let obj = {
        file: f.file,
      };
      this.api.uploadf("/5ce7e4f35dc2b", obj).then((r) => {
        this.schoolForm.photo.push({
          id: 0,
          url: r.data.fileUrl,
        });
      });
    },

    // 上传营业执照
    BusinessFun(f) {
      let obj = {
        file: f.file,
      };
      this.api.uploadf("/5ce7e4f35dc2b", obj).then((r) => {
        this.schoolForm.require_pic = [];
        this.schoolForm.require_pic.push({
          id: 0,
          url: r.data.fileUrl,
        });
      });
    },

    // 打开图片
    openPhoto(o) {
      window.open(o.url);
    },

    // 园所提交
    schoolSubmit() {
      // 5cee8de5c4fcb 编辑
      // 5cee58e424256 新增
      this.schoolForm.country = 1;
      this.schoolForm.avatar = "";
      if (this.schoolForm.require_pic) {
        if (typeof this.schoolForm.require_pic === "object") {
          this.schoolForm.require_pic = this.schoolForm.require_pic[0].url;
        }
      }
      this.api
        .post(
          this.schoolForm.sid ? "/5cee8de5c4fcb" : "/5cee58e424256",
          this.schoolForm
        )
        .then((r) => {
          this.$message({
            message: "创建成功，请重新登录",
            type: "success",
          });
          this.Cookies.remove("UserToken");
          this.$router.push({ path: "/login" });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.edit {
  margin-top: 20px;
  background: white;
  padding: 20px;
  .boxWid {
    width: 100%;
  }
  .boxHei {
    height: 81px;
  }
}

.shortMessageTextBox {
  position: relative;
  .shortMessageText {
    position: absolute;
    right: 15px;
    top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/boss/addSchool.vue